import { render, staticRenderFns } from "./article.pug?vue&type=template&id=6ccfdda0&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./article.scss?vue&type=style&index=0&id=6ccfdda0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccfdda0",
  null
  
)

export default component.exports